module.exports = __webpack_public_path__ + "static/media/BZ.962aa3d0.svg";